import { render } from "./NumberInput.vue?vue&type=template&id=0bc374bb&scoped=true&ts=true"
import script from "./NumberInput.vue?vue&type=script&lang=ts"
export * from "./NumberInput.vue?vue&type=script&lang=ts"

import "./NumberInput.vue?vue&type=style&index=0&id=0bc374bb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bc374bb"]])

export default __exports__